import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Footer, Header } from "@/pages/home/Chrome";

/** Shared brand shell for activation, pricing, playlists and legal pages. */
export default function MarketingLayout() {
  return (
    <div className="moova moova-shell">
      <Helmet>
        <meta name="theme-color" content="#0B0B14" />
      </Helmet>
      <Header />
      <main id="main" className="moova-page">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
